/**
 * Подготавливает выбранное условие размещения для публикации или сохранения в черновик.
 * Используется в цикле.
 *
 * @param term выбранное условие размещения
 */
export const processPublishTerm = (term) => {
  const {
    id,
    dynamicPrice,
    selectedPeriod: { type, tariffIdentificator, recommendedServicePackageId, token },
  } = term;

  const isSubscription = id === 'servicePackage';

  const services = isSubscription ? term.selectedPeriod.services : term.services;
  const days = isSubscription ? 1 : term.selectedPeriod.days;

  return {
    services,
    dynamicPrice,
    type,
    days,
    tariffIdentificator,
    recommendedServicePackageId,
    ...(!!token && { token }),
  };
};
